webpackJsonp([80],{

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wangeditor__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wangeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wangeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(77);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wangEditor',
  props: {
    value: {
      type: String
    },
    tag: {
      type: String,
      default: 'div'
    },
    menus: Array,
    /**
     [
     'head',  // 标题
     'bold',  // 粗体
     'italic',  // 斜体
     'underline',  // 下划线
     'strikeThrough',  // 删除线
     'foreColor',  // 文字颜色
     'backColor',  // 背景颜色
     'link',  // 插入链接
     'list',  // 列表
     'justify',  // 对齐方式
     'quote',  // 引用
     'emoticon',  // 表情
     'image',  // 插入图片
     'table',  // 表格
     'video',  // 插入视频
     'code',  // 插入代码
     'undo',  // 撤销
     'redo'  // 重复
     ]
     */
    colors: Array,
    /**
     [
     '#000000',
     '#eeece0',
     '#1c487f',
     '#4d80bf',
     '#c24f4a',
     '#8baa4a',
     '#7b5ba1',
     '#46acc8',
     '#f9963b',
     '#ffffff'
     ]
     */
    config: Object,
    zIndex: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      editor: null
    };
  },

  watch: {
    value: function value() {
      // 双向绑定，父组件同步到子组件
      if (this.value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 实例化编辑器
    // 双向绑定，子组件同步到父组件
    this.editor = new __WEBPACK_IMPORTED_MODULE_1_wangeditor___default.a(this.$el);

    this.editor.customConfig.uploadImgServer = this.uploadFilePath;
    this.editor.customConfig.uploadFileName = this.uploadFileName;
    this.editor.customConfig.uploadImgHeaders = {
      'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* getToken */])()
    };
    this.editor.customConfig.uploadImgParams = this.uploadFileParams;

    this.editor.customConfig.uploadImgHooks = {
      before: function before(xhr, editor, files) {

        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function success(xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      fail: function fail(xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function error(xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function timeout(xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function customInsert(insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.detail.url;
        insertImg(url);
      }
    };

    this.editor.customConfig.onchange = function (html) {
      if (html !== _this.value) {
        _this.$emit('input', html);
      }
    };
    // 获得焦点事件
    this.editor.customConfig.onfocus = function () {
      _this.$emit('focus');
    };
    // 失去焦点事件
    this.editor.customConfig.onblur = function () {
      _this.$emit('blur');
    };
    // 配置数据
    this.editor.customConfig.zIndex = this.zIndex;
    if (this.menus) this.editor.customConfig.menus = this.menus;
    if (this.colors) this.editor.customConfig.colors = this.colors;
    if (this.config) this.editor.customConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.editor.customConfig, this.config);
    // 创建编辑器
    this.editor.create();
    // 赋初始值
    this.editor.txt.html(this.value);
  },
  destroyed: function destroyed() {
    // 销毁编辑器
    this.editor._offAllEvent();
  },
  render: function render(h) {
    return h(this.tag, {
      class: {},
      style: {}
    }, this.$slots.default);
  }
});

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(79);

/***/ }),

/***/ 2769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WangEditorV3Deprecated__ = __webpack_require__(1593);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WangEditor: __WEBPACK_IMPORTED_MODULE_3__components_WangEditorV3Deprecated__["a" /* default */] },
  data: function data() {
    return {
      id: 0,
      formRules: {
        title: [{ required: true, message: '活动名称不能为空', trigger: 'blur' }, { min: 2, max: 16, message: '活动名称长度应为2到16个字符', trigger: 'blur' }],
        starttime: [{ required: true, message: '活动开始时间不能为空', trigger: 'blur' }],
        endtime: [{ required: true, message: '活动结束时间不能为空', trigger: 'blur' }, { validator: this.endtimeValidator, trigger: 'blur' }],
        skip_time: [{ required: true, message: '跳过时间不能为空', trigger: 'blur' }, { validator: this.positiveIntegerValidator, trigger: 'blur' }],
        activity_url: [{ required: true, message: '活动添加链接不能为空', trigger: 'blur' }],
        img_url: [{ required: true, message: '上传图片不能为空', trigger: 'blur' }]
      },
      form: {
        title: '',
        content: '',
        skip_time: '',
        starttime: '',
        endtime: '',
        activity_url: '',
        img_url: ''

      }
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getLaunchPageActivityDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
      });
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createLaunchPageActivityData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/launch-page-activity/table/' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('updateLaunchPageActivityData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/launch-page-activity/table/' });
        });
      });
    },
    onChangeFile: function onChangeFile(file, fileList) {
      var isExcel = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      var isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!');
        this.$refs.upload.clearFiles();
        return false;
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!');
        this.$refs.upload.clearFiles();
        return false;
      }
      this.onUploadFile(file.raw);
    },
    onUploadFile: function onUploadFile(file) {
      var _this5 = this;

      var formData = new FormData();
      formData.append('file', file);
      return request.alert('uploadFair', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this5.form.img_url = data;
        _this5.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      this.form.img_url = '';
    },

    // 验证活动结束时间
    endtimeValidator: function endtimeValidator(rule, value, callback) {
      if (Date.parse(this.form.endtime) <= Date.parse(this.form.starttime)) {
        callback(new Error('活动结束时间必须晚于活动开始时间'));
      } else {
        callback();
      }
    },
    positiveIntegerValidator: function positiveIntegerValidator(rule, value, callback) {
      if (value && (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(value)) || Number(value) <= 0)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LaunchPageActivityForm_vue__ = __webpack_require__(2769);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd364452_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaunchPageActivityForm_vue__ = __webpack_require__(4478);
function injectStyle (ssrContext) {
  __webpack_require__(4472)
  __webpack_require__(4474)
  this["$style"] = __webpack_require__(4476)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd364452"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LaunchPageActivityForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd364452_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaunchPageActivityForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d1ed1d2e", content, true, {});

/***/ }),

/***/ 4473:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".avatar-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload:hover{border-color:#409eff}.avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.el-icon-plus:before{line-height:178px}.avatar{width:178px;height:178px;display:block}", "", {"version":3,"sources":["/workspace/src/views/launch-page-activity/pages/LaunchPageActivityForm.vue"],"names":[],"mappings":"AACA,4BAA4B,0BAA0B,kBAAkB,eAAe,kBAAkB,eAAe,CACvH,AACD,kCAAkC,oBAAoB,CACrD,AACD,sBAAsB,eAAe,cAAc,YAAY,aAAa,kBAAkB,iBAAiB,CAC9G,AACD,qBAAqB,iBAAiB,CACrC,AACD,QAAQ,YAAY,aAAa,aAAa,CAC7C","file":"LaunchPageActivityForm.vue","sourcesContent":["\n.avatar-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden\n}\n.avatar-uploader .el-upload:hover{border-color:#409EFF\n}\n.avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center\n}\n.el-icon-plus:before{line-height:178px\n}\n.avatar{width:178px;height:178px;display:block\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4474:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4475);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5118ea49", content, true, {});

/***/ }),

/***/ 4475:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LaunchPageActivityForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4476:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4477);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("58cf6633", content, true, {});

/***/ }),

/***/ 4477:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LaunchPageActivityForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/launch-page-activity/table"}},[_vm._v("活动管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"活动名称","prop":"title"}},[_c('el-input',{model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"content","label":"活动描述"}},[_c('wang-editor',{attrs:{"menus":['head','bold','italic','underline','strikeThrough','foreColor','list','justify','quote','undo','redo'],"colors":['#f3605b', '#333']},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"starttime","label":"活动开始时间:"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetime","placeholder":"请选择活动开始时间","align":"center"},model:{value:(_vm.form.starttime),callback:function ($$v) {_vm.$set(_vm.form, "starttime", $$v)},expression:"form.starttime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"endtime","label":"活动结束时间:"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetime","placeholder":"请选择活动结束时间","align":"center"},model:{value:(_vm.form.endtime),callback:function ($$v) {_vm.$set(_vm.form, "endtime", $$v)},expression:"form.endtime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"跳过时间","prop":"skip_time"}},[_c('el-col',{attrs:{"span":"10"}},[_c('el-input',{model:{value:(_vm.form.skip_time),callback:function ($$v) {_vm.$set(_vm.form, "skip_time", $$v)},expression:"form.skip_time"}},[_c('template',{slot:"append"},[_vm._v("秒")])],2)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"添加链接","prop":"activity_url"}},[_c('el-input',{model:{value:(_vm.form.activity_url),callback:function ($$v) {_vm.$set(_vm.form, "activity_url", $$v)},expression:"form.activity_url"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"img_url","label":"上传图片"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"","auto-upload":false,"show-file-list":false,"on-change":_vm.onChangeFile,"on-remove":_vm.handleRemove}},[(_vm.form.img_url)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.form.img_url}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})]),_vm._v(" "),_c('span',{staticClass:"color-info",staticStyle:{"font-size":"12px","line-height":"40px"}},[_vm._v("只能上传jpg/jpeg/png文件，且不超过5M")])],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/launch-page-activity-form.f48237a7a47e20369f39.js